import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  FileComment,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/fileComment`;

export interface UpdateFileCommentCommandPayload {
  fileCommentId: string;
  NewContent: string;
}

export const updateFileCommentRequest = (
  payload: UpdateFileCommentCommandPayload,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.PUT, json: payload },
});

export const updateFileCommentCommand = async (
  payload: UpdateFileCommentCommandPayload,
): Promise<BackResponse<FileComment> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<FileComment>>(
      updateFileCommentRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
